import React from "react";

import ProjectList from "./ProjectList";
import projects from "../../data/projects.json";

const Projects = () => <ProjectList projects={projects} />;

export default Projects;
